import React, { useState } from 'react';
import { Box, Grid, ChakraProvider, GridItem, Button, useBreakpointValue } from '@chakra-ui/react';
import theme from '../../config/themeSeeker';
import { useSelector } from 'react-redux';
import Header from '../../components/seeker/header';
import Sidebar from '../../components/seeker/sideBar';
import JobList from '../../components/seeker/JobListHome';
import SearchJob from '../../components/seeker/SearchJob';
import ProfileOverview from '../../components/seeker/profileOverview';
import ProfileStatus from '../../components/seeker/profileStatus';
import MyProfile from './MyProfile'; // Import MyProfile component
import backgroundImage from '../../assets/seekerhome2.jpg';
import GetHelpPage from '../../components/seeker/getHelp';
import Settings from '../../components/seeker/settings';
import MyCalendar from '../../components/seeker/myCalendar';
import axios from 'axios';
import DocumentsComponent from '../../components/seeker/documents'; // Import DocumentsComponent
import AllJobs from '../../components/seeker/allJobsHome';
import JobApprovedList from '../../components/seeker/jobApprovedList';
import { useRefreshContext } from '../../utils/context/refreshContext';
import Payments from '../../components/seeker/payments';
import Earnings from '../../components/seeker/Earnings';
import PrivacyPolicy from '../../components/provider/privacyPolicy';

const SeekerHome = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [selectedView, setSelectedView] = useState('home'); // State to track selected view
    const [selectedProfileSubView, setSelectedProfileSubView] = useState('personalInfo'); // State to track selected profile subview
    const [homePageData, setHomePageData] = React.useState({
      profile_image_url:'',
      avatarSrc: '',
      FullName: '',
      userName: '',
      registerNumber: '',
      password: '',
      email: '',
      contact_no: '',
      bio: '',
      address: {
        street: '',
        city: '',
        state: '',
        country: '',
        pinCode: ''
      },
      experience: '',
      skills: '',
      services: '',
      role: '',
      country_code: '',
      individual_identity: '',
      agencyDetails: {
        licenseId: '',
        certification: '',
        certificationExpiry: '',
        issuingAuthority: ''
      },
      organizational_specialization: ''
    });
    const { refresh, triggerRefresh } = useRefreshContext();
    const assignedJobs = useSelector((state) => state.assignedJobs.assignedJobs); // Retrieve assignedJobs from Redux

    React.useEffect(() => {
      const fetchHomePageData = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        if (!ticketToken) {
          console.error('No ticket token found in sessionStorage');
          window.location.href = '/'; // Redirect to the root
          return;
        }
        // console.log('Ticket Token:', ticketToken);
    
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/applicant/get-homepage-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );
    
            console.log('Response data: ok ? :', response.data); // Log the response data
    
            
                setHomePageData({
                    profile_image_url: response.data.data.profile_image_url || '',
                    FullName: response.data.data.FullName || '',
                    registerNumber: response.data.data.registerNumber || '',
                    userName: response.data.data.userName || '',
                    email: response.data.data.email || '',
                    role: response.data.data.role || '',
                    country_code: response.data.data.country_code || '',
                    address: {
                        street: response.data.data.address?.street || '',
                        city: response.data.data.address?.city || '',
                        state: response.data.data.address?.state || '',
                        country: response.data.data.address?.country || '',
                        pinCode: response.data.data.address?.pinCode || ''
                    },
                    individual_identity: response.data.data.individual_identity || '',
                    agencyDetails: {
                        licenseId: response.data.data.agencyDetails?.licenseId || '',
                        certification: response.data.data.agencyDetails?.certification || '',
                        certificationExpiry: response.data.data.agencyDetails?.certificationExpiry || '',
                        issuingAuthority: response.data.data.agencyDetails?.issuingAuthority || ''
                    },
                    organization_type: response.data.data.organization_type || '',
                    organizational_specialization: response.data.data.organizational_specialization || '',
                    bio: response.data.data.bio || '',
                    contact_no: response.data.data.contact_no || '',
                    experience: response.data.data.experience || '',
                    proffession: response.data.data.proffession || '',
                    skills: response.data.data.skills || '',
                    services: response.data.data.services || ''
                });
          
        } catch (error) {
            console.error('Error fetching profile data:', error);
        }
    };
  
      fetchHomePageData();
    }, [refresh]);

    const isLargeScreen = useBreakpointValue({ base: false, lg: true });

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const handleSelectItem = (item) => {
        setSelectedView(item); // Update selected view based on sidebar selection
    };

    const handleSelectProfileSubView = (subView) => {
        setSelectedProfileSubView(subView); // Update selected profile subview
    };

    const navigateToHome = () => {
        setSelectedView('home');
    };

    return (
        <ChakraProvider theme={theme}>
          <Box position="relative" h="100vh">
            <Box
              position={isLargeScreen ? 'fixed' : 'absolute'}
              left='0'
              top='0'
              zIndex='3'
              w={isSidebarOpen || isLargeScreen ? '200px' : '0'}
              h='100vh'
              bg="white"
              overflow='hidden'
              transition="width 0.3s ease-in-out"
            >
              {(isSidebarOpen || isLargeScreen) && (
                <Sidebar 
                  onSelectItem={handleSelectItem} // Pass handler to Sidebar
                  selectedItem={selectedView} 
                  onSelectProfileSubView={handleSelectProfileSubView} // Pass profile subview handler
                />
              )}
            </Box>

            {!isLargeScreen && (
              <Button
                position="fixed"
                top="10px"
                left={isSidebarOpen ? '200px' : '0'}
                zIndex="4"
                colorScheme="teal"
                onClick={toggleSidebar}
                size="sm"
                width="40px"
                borderLeftRadius="0"
              >
                {isSidebarOpen ? '<' : '>'}
              </Button>
            )}

            <Grid
              templateAreas={`"header"
                              "content"`}
              gridTemplateRows={'50px 1fr'}
              gridTemplateColumns={'1fr'}
              h='100vh'
              ml={isLargeScreen ? '200px' : '0'}
              transition="margin-left 0.3s ease-in-out"
              overflowY="auto"
            >
              <GridItem area={'header'} w="100%" h="50px" position="sticky" top="0" left={isLargeScreen ? '200px' : '0'} zIndex="2" bg="white">
                <Header 
                    userName={homePageData.FullName || ''} 
                    userEmail={homePageData.email || ''} 
                    onHomeClick={navigateToHome}
                />
              </GridItem>
              <GridItem area={'content'} w="100%" h="calc(100% - 50px)" mt="0"> {/* Remove margin-top */}
                {selectedView === 'profile' && selectedProfileSubView === 'personalInfo' && <MyProfile initialFullName={homePageData.FullName || ''} initialEmail={homePageData.email || ''} initialRole={homePageData.role || ''}/>}
                {selectedView === 'profile' && selectedProfileSubView === 'documents' && <DocumentsComponent />} {/* Render DocumentsComponent */}
                {selectedView === 'profile' && selectedProfileSubView === 'privacy' && <PrivacyPolicy />}
                {selectedView === 'help' && <GetHelpPage />}
                {selectedView === 'settings' && <Settings />}
                {selectedView === 'mySchedule' && <MyCalendar />}
                {selectedView === 'payments' && <Payments />}
                {selectedView === 'earnings' && <Earnings />}
                {selectedView === 'jobs' && <AllJobs />}
                {selectedView === 'home' && (
                  <Grid
                    gridTemplateRows={'120px auto 1fr'}
                    h="100%"
                  >
                      <GridItem
                      bgImage={`url(${backgroundImage})`}
                      bgSize="cover"
                      bgPosition="center"
                      bgRepeat="no-repeat"
                      position="relative"
                      zIndex="1"
                  >
                      <ProfileStatus />
                  </GridItem>
                    <GridItem overflowX="auto" whiteSpace="nowrap">
                    <JobApprovedList assignedJobs={assignedJobs} />
                    </GridItem>
                    <GridItem>
                      <JobList />
                    </GridItem>
                  </Grid>
                )}
              </GridItem>
            </Grid>
          </Box>
        </ChakraProvider>
    );
}

export default SeekerHome;